import * as React from "react";
import { forwardRef } from "react";
const SvgFastforwardIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "ctrl-forward") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("path", { d: "M15.65,7.241l-7-6A1,1,0,0,0,7,2V5.827L1.65,1.241A1,1,0,0,0,0,2V14a1,1,0,0,0,1.65.759L7,10.173V14a1,1,0,0,0,1.65.759l7-6a1,1,0,0,0,0-1.518Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgFastforwardIcon);
export { ForwardRef as ReactComponent };
